export const environment = {
    production: true,
    apiBaseUrl: "https://dev-api.happygrocers.co",
    appUrl: 'https://dev.happygrocers.co',
    omisePublicKey: "pkey_test_5oeqnrh6z34ym1755zp", // test key omise second
    GOOGLE_MAPS_API_KEY: 'AIzaSyBv_Y7rQI2BRJaPQ8E_JeMqXOI-MOrVuaw',
  };
